import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
  linkedSignal,
  output,
  viewChild
} from '@angular/core';
import { CountdownComponent, CountdownEvent } from 'ngx-countdown';

import { DateService } from '~core/services/date.service';

@Component({
  selector: 'auth-countdown',
  standalone: false,
  templateUrl: './auth-countdown.component.html',
  styleUrls: ['./auth-countdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthCountdownComponent {
  private _dateService = inject(DateService);
  private _cdRef = inject(ChangeDetectorRef);

  countdown = viewChild<CountdownComponent>('countdown');

  expiresAt = input<string | null | undefined>(null);
  resendOtp = output<void>();

  countdownSeconds = linkedSignal(() => {
    const expires = this.expiresAt();
    const newSeconds = expires ? this.getCountdownSeconds(expires) : 0;
    const countdownInstance = this.countdown();

    if (countdownInstance && newSeconds > 0) {
      setTimeout(() => {
        countdownInstance.config.leftTime = newSeconds;
        countdownInstance.restart();
        this._cdRef.detectChanges();
      }, 0);
    }

    return newSeconds;
  });

  canResendOtp = linkedSignal(() => this.countdownSeconds() <= 0);

  onCountdownEvent(event: CountdownEvent): void {
    if (event.action === 'done') {
      this.canResendOtp.set(true);
    }
  }

  getCountdownSeconds(expiresAt?: string | null): number {
    if (!expiresAt) return 0;
    const now = this._dateService.instance();
    const expires = this._dateService.instance(expiresAt);
    return Math.max(expires.diff(now, 'seconds'), 0);
  }

  onOtpResend(): void {
    this.canResendOtp.set(false);
    this.resendOtp.emit();
  }
}
